import React, { useEffect, useState } from "react";
import UserWrapper from "./Group.style";
import PageTitle from "components/common/PageTitle";
import { connect } from "react-redux";
import GroupServices from "../../api/GroupServices";
import GroupForm from "../../components/group/GroupForm";
import EncryptDecrypt from "../../api/EncryptDecrypt";

const GroupEdit = props => {
  const [editedData, setEditedData] = useState(undefined);
  const hasParam = props.match.params.id;
  useEffect(() => {
    if (hasParam) {
      const params = {
        id: hasParam
      };
      GroupServices.view(params).then(res => {
        let data = EncryptDecrypt.decrypt(res.data);
        setEditedData(data.data);
      });
    }
  }, []);

  const submitFormHandler = (data, action) => {
    setTimeout(() => {
      props.history.push("/group");
    }, 2000);
  };

  return (
    <UserWrapper {...props}>
      <div className="pos-relative">
        <PageTitle
          props={props}
          title="sidebar.group"
          className="plr-15"
          breadCrumb={[
            {
              name: "sidebar.dashboard",
              url: "/dashboard"
            },
            {
              name: "sidebar.group",
              url: "/group"
            },
            {
              name: hasParam ? "action.edit" : "action.add"
            }
          ]}
        />
        <div
          className="back-icon fs-15 demi-bold-text cursor-pointer"
          onClick={() => props.history.push("/group")}
        >
          <i className="fas fa-step-backward"></i> Back
        </div>
      </div>

      <div className="plr-15">
        <div className="roe-card-style mtb-15">
          <div className="roe-card-header module-header">
            <div className="flex-1 fs-16 demi-bold-text">
              <span className="hash"># </span> {hasParam ? "Edit" : "Add"} Group
            </div>
          </div>
          <div className="roe-card-body">
            <GroupForm
              onSubmit={submitFormHandler}
              editedData={editedData}
              action={hasParam ? "edit" : "add"}
              {...props}
            />
          </div>
        </div>
      </div>
    </UserWrapper>
  );
};

const mapStateToProps = state => {
  return {
    ...state.themeChanger,
    authData: {
      adminRoleId: state.auth.admin_role_id,
      adminRole: state.auth.admin_role,
      service_id: state.auth.service_id
    }
  };
};

export default connect(mapStateToProps, null)(GroupEdit);
